<template>
  <div>
    原密码（首次登录不需要输入）：
    <Input v-model="OldPassword" placeholder="输入原密码" style="width: auto;margin-left: 20px;" />
    <br />
    <br />新密码：
    <Input
      v-model="Password"
      placeholder="输入新密码"
      type="password"
      style="width: auto;margin-left: 20px;"
    />
    <br />
    <br />
    <Button type="primary" @click="save">确定</Button>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "Config",

  data() {
    return {
      OldPassword: "",
      Password: ""
    };
  },
  mounted: function() {},
  methods: {
    save() {
      api
        .UserResetPwd({
          oldPwd: this.OldPassword,
          newPwd: this.Password
        })
        .then(res => {
          this.$layer.alert(res.body.message);
        });
    }
  }
};
</script>

<style scoped>
</style>
